__turbopack_context__.v({
  "background": "RRI0fq_background",
  "copyBlock": "RRI0fq_copyBlock",
  "decoration": "RRI0fq_decoration",
  "heroCta": "RRI0fq_heroCta",
  "heroMediaArea": "RRI0fq_heroMediaArea",
  "heroPoster": "RRI0fq_heroPoster",
  "heroSignalBand": "RRI0fq_heroSignalBand",
  "heroVideo": "RRI0fq_heroVideo",
  "location": "RRI0fq_location",
  "mediaFrame": "RRI0fq_mediaFrame",
  "overlay": "RRI0fq_overlay",
  "section": "RRI0fq_section",
  "statGroup": "RRI0fq_statGroup",
  "statItem": "RRI0fq_statItem",
  "statLabel": "RRI0fq_statLabel",
  "statValue": "RRI0fq_statValue",
  "statsRow": "RRI0fq_statsRow",
  "subtitle": "RRI0fq_subtitle",
  "title": "RRI0fq_title",
  "titleWrap": "RRI0fq_titleWrap",
});
